import { types as t, Instance } from 'mobx-state-tree';
import Sensor from '~/mst/models/device/sensor';

const AlphaSenseSensor = t.compose(
  t.model({
    pm1_stel_alert: t.frozen(),
    pm25_stel_alert: t.frozen(),
    pm10_stel_alert: t.frozen(),
    stel_timeout: t.frozen()
  }),
  Sensor
);

export interface IAlphaSenseSensor extends Instance<typeof AlphaSenseSensor> {}

export default AlphaSenseSensor;
